module.exports = __webpack_public_path__ + "916eb7297428272e5f1747ae8806ea14.jpg";